// let httpRequestUrl = 'http://192.168.31.110:8080/site-nanaco/' // devUrl
let httpRequestUrl = "/"; // proUrl
export default httpRequestUrl;
